var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 41,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#people_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "people_svg__b",
  width: 41,
  height: 41,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.334.5h40v40h-40z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2.344,
  mask: "url(#people_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.318 33.078H6.193a4.69 4.69 0 0 0-4.687 4.688v1.562h12.5v-1.562a4.69 4.69 0 0 0-4.688-4.688M21.897 9.484h-3.125a4.687 4.687 0 0 0-4.688 4.688v1.562h12.5v-1.562a4.687 4.687 0 0 0-4.687-4.688M34.475 33.078H31.35a4.69 4.69 0 0 0-4.688 4.688v1.562h12.5v-1.562a4.69 4.69 0 0 0-4.687-4.688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.662 29.172a3.906 3.906 0 1 1-7.812 0 3.906 3.906 0 0 1 7.812 0M24.24 5.578a3.906 3.906 0 1 1-7.812 0 3.906 3.906 0 0 1 7.812 0M36.818 29.172a3.906 3.906 0 1 1-7.812 0 3.906 3.906 0 0 1 7.812 0M20.334 22.922v-7.188M22.678 25.266a2.344 2.344 0 1 1-4.688 0 2.344 2.344 0 0 1 4.688 0M18.094 25.96l-6.608 2.053M29.18 28.013l-6.608-2.053"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "people_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.334.5h40v40h-40z"
})))));
export default SvgPeople;